module.exports = __webpack_public_path__ + "static/img/0000镇赉叫号.711ba41.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/picImgs/0000镇赉叫号.jpg
// module id = akKg
// module chunks = 0